import React from "react";
import "./Skills.css";
import Img from "./assets/skill.jpg";
import { IconContext } from "react-icons/lib";

import { motion } from "framer-motion";
import SkillsData from "./SkillData";
import SkillSection from "./SkillSection";
const skills = () => {
  return (
    <div className="bg-secondary-background-color  pb-8 flex flex-col justify-evenly gap-8">
      <h2 className="flex justify-center mb-2 py-8 title text-3xl">SkILLS</h2>
      <SkillSection img={Img} skills={SkillsData.Fields} title="Fields" />
      <SkillSection
        img={Img}
        langList={SkillsData.SkillsData}
        order="img-first"
        title="Languages | Libaries | Frameworks"
      />
    </div>
  );
};

export default skills;
